module.exports = __webpack_public_path__ + "static/media/nora_blake.937647e6.pdf";